import React from 'react';

import HeaderNew from './Header';
import HeaderOld from './HeaderOld';
import { useSystem } from 'store/hooks';

export interface HeaderProps {
	onActiveNavClick?: () => void;
}

// Main export that renders the appropriate header based on AI dashboard access.
export function Header({ onActiveNavClick }: HeaderProps) {
	const { data } = useSystem();
	const hasAiTokens = data?.user.has_ai_tokens ?? false;
	const aiDashboardEnabled = data?.user.ai_dashboard_enabled ?? false;
	const aiAccessEnabled = data?.user.ai_access_enabled ?? false;
	const canUseAiDashboard = hasAiTokens || (aiDashboardEnabled && aiAccessEnabled);

	if (canUseAiDashboard) {
		return React.createElement(HeaderNew, { onActiveNavClick });
	}

	return React.createElement(HeaderOld, { onActiveNavClick });
}

export default Header;
